import React, { useEffect } from "react";
import clsx from "clsx";
import I18n from "i18n-js";
import Switch from "../../Switch/Switch";
import ErrorHelper from "../../Errors/ErrorHelper";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import subYears from 'date-fns/subYears';

const PropertyDetailsBuilderChannelPartnersAccountDetials = (props) => {
  var tabClasses = clsx({
    active: props.active_tab == "partner_details",
    "tab-pane": true,
  });

  // useEffect(() => {
  //   console.log('here', document.getElementById('autocomplete'))
  //   const autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address',] });
  //   autocomplete.addListener("place_changed", () => { handleAdressSelect(props) });
  // }, [props.counter]);



  return(
    <div className={tabClasses} >
      {props.errors ? ErrorHelper.renderErrors(props.errors, ['ru_contact_first_name', 'ru_contact_last_name', 'ru_contact_phone', 'ru_contact_email']) : null}
      {renderRentalsUnitedPannel(props)}
    </div>
  );
};

const renderRentalsUnitedPannel = (props) => {
  return(
    <div className="row">
      <div className="col-md-12">
        <div className="panel panel-default">
          {renderRentalsUnitedPannelHead(props)}
          {props.property.ru_id ? renderRentalsUnitedPannelBody(props) : null}
        </div>
      </div>
    </div>
  );
};

const renderRentalsUnitedPannelHead = (props) => {
  return (
    <div className="panel-heading flexed">
      <h3 className="panel-title">
        {I18n.t('rentals_united')}
        {/* <a href="#" className="ru-terms-link">{I18n.t('terms_of_service')}</a> */}
      </h3>
      {/* {<Switch
        onChange={props.onFlipSwitch}
        switchId='ru_active'
        name='ru_active'
        value={props.ru_active}
        onText="enabled"
        offText="disabled"
        additionalClasses="switch-wrapper"
      />} */}
    </div>
  );
};

const renderRentalsUnitedPannelBody = (props) => {
  return(
    <div className="panel-body">
      {renderRUContactRow(props)}
      {/* {renderRUAdresstRow(props)} */}
    </div>
  );
};

const renderRUContactRow = (props) => {
  return(
    <div className="row container">
      <div className="col-md-2 form-group">
        <label>{I18n.t('first_name')}*</label>
        <input
          className={ErrorHelper.renderFieldClasses('ru_contact_first_name', props.errors, 'form-control')}
          value={props.ru_contact_first_name}
          name="ru_contact_first_name"
          onChange={props.onChange}
        />
        {ErrorHelper.renderFieldErrors('ru_contact_first_name', props.errors)}
      </div>
      <div className="col-md-2 form-group">
        <label>{I18n.t('last_name')}*</label>
        <input
          className={ErrorHelper.renderFieldClasses('ru_contact_last_name', props.errors, 'form-control')}
          value={props.ru_contact_last_name}
          name="ru_contact_last_name"
          onChange={props.onChange}
        />
        {ErrorHelper.renderFieldErrors('ru_contact_last_name', props.errors)}
      </div>
      <div className="col-md-2 form-group">
        <label>{I18n.t('email')}*</label>
        <input
          className={ErrorHelper.renderFieldClasses('ru_contact_email', props.errors, 'form-control')}
          value={props.ru_contact_email}
          name="ru_contact_email"
          onChange={props.onChange}
        />
        {ErrorHelper.renderFieldErrors('ru_contact_email', props.errors)}
      </div>
      <div className="col-md-2 form-group">
        <label>{I18n.t('phone')}*</label>
        <input
          className={ErrorHelper.renderFieldClasses('ru_contact_phone', props.errors, 'form-control')}
          value={props.ru_contact_phone}
          name="ru_contact_phone"
          onChange={props.onChange}
        />
        {ErrorHelper.renderFieldErrors('ru_contact_phone', props.errors)}
      </div>
      <div className="col-md-2 form-group">
        <label>{I18n.t('dob')}*</label>
        <DatePickerInput
          selectedDate={props.ru_contact_birthdate ? props.ru_contact_birthdate : null}
          dateFormat={'yyyy-MM-dd'}
          classNames={ErrorHelper.renderFieldClasses('ru_contact_birthdate', props.errors, 'form-control')}
          onChange={props.onChangeBirthdate}
          name="ru_contact_birthdate"
          customChangeSource={"syntheticTarget"}
          customChangeHandler={props.onChange}
          placeholderText={'YYYY-MM-DD'}
          maxDate={subYears(new Date, 18)}
          minDate={subYears(new Date, 99)}
        />
        {ErrorHelper.renderFieldErrors('ru_contact_birthdate', props.errors)}
      </div>
    </div>
  );
};

const renderRUAdresstRow = (props) => {
  return(
    <div className="row container">
      <div className="col-md-6">
        <div className="form-group">
          <label>{I18n.t("address_1")}*</label>
          <input
            id="autocomplete"
            type="text"
            className="form-control"
            name="address_1"
            onChange={props.onChange}
            value={props.ru_contact_address}
          />
        </div>
      </div>

    </div>
  );
};

const handleAdressSelect = (props) => {
  let addressObject = this.autocomplete.getPlace()
  let address = addressObject.address_components
  for (let i = 0, ilen = address.length; i < ilen; i++) {
    for (let j = 0, jlen = address[i].types.length; j < jlen; j++) {
      if (address[i].types[j] === "street_number") {
        var street_number = address[i].long_name
      }
      if (address[i].types[j] === "route") {
        var route = address[i].long_name
      }
      if (address[i].types[j] === "locality") {
        var city = address[i].long_name
      }
      if (address[i].types[j] === "administrative_area_level_1") {
        var state_province = address[i].long_name
      }
      if (address[i].types[j] === "postal_code") {
        var postal_code = address[i].long_name
      }
      if (address[i].types[j] === "country") {
        var country = address[i].long_name
      }
    }
  }

  let objForState = {
    ru_contact_address: street_number ? `${street_number} ${route}` : route,
    ru_contact_city: city,
    ru_country: country,
    ru_contact_zip_code: postal_code
  };

  props.onGeoSelectAddress(objForState);
};

export default PropertyDetailsBuilderChannelPartnersAccountDetials